<script>
    import Slider from "../components/Slider.svelte";
    import {onMount} from 'svelte';

    var modal;
    var modalImg;
    var caption;
    var closeSpan;

    onMount(() => {
        closeSpan.onclick = function () {
            modal.style.display = "none";
        }
    });

    let slides = [
        {src: "./svelte-site/img/gympics/alakerta.jpg"},
        {src: "./svelte-site/img/gympics/ylakerta.jpg"},
    ];

    // Lisätään pakolliset id:t slidesseihin
    for (var i = 0; i < slides.length; i++) {
        slides[i].id = (i + 1);
    }


    const images = [
        {src: "/svelte-site/img/gallery/kahvakuulat.jpg", alt: "Kahvakuulat"},
        {src: "/svelte-site/img/gallery/jalkaprassi.jpg", alt: "Kahvakuulat, takana jalkaprässi"},
        {src: "/svelte-site/img/gallery/juoksumatto.jpg", alt: "Juoksumatto"},
        {src: "/svelte-site/img/gallery/lavat.jpg", alt: "Painonnostolavat"},
        {src: "/svelte-site/img/gallery/levypainot.jpg", alt: "Levypainot"},
        {src: "/svelte-site/img/gallery/selkapenkki.jpg", alt: "Selkä- ja vatsapenkki"},
        {src: "/svelte-site/img/gallery/smith-penkki.jpg", alt: "Smith ja penkkipunnerruspaikka"},
        {src: "/svelte-site/img/gallery/spinningpyora.jpg", alt: "Spinningpyörä"},
        {src: "/svelte-site/img/gallery/ylatalja.jpg", alt: "Ylätalja"},
        {src: "/svelte-site/img/gallery/ristitalja.jpg", alt: "Ristitalja"},
        {src: "/svelte-site/img/gallery/kasipainot.jpg", alt: "Käsipainot"},
    ];

    function imgOpen(src, alt) {
        modal.style.display = "block";
        modalImg.src = src;
        console.log(alt);
        caption.innerHTML = alt;
    }

</script>
<div>
    <Slider sliderSlides="{slides}" sliderSpeedMs="7000"/>
</div>
<div class="page">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 ">
                <h1>Dynamosali - Toiminnallinen kuntosali</h1>
                <h2>Millaista Dynamosalilla on ?</h2>

                <p>Dynamosalilta löydät kattavat ja laadukkaat välineet toiminnalliseen
                    harjoitteluun, monipuoliseen voimaharjoitteluun sekä perinteiseen kuntosaliharjoitteluun.</p>

                <p>Salin puitteet mahdollistavat juuri sinulle sopivan, kehittävän ja monipuolisen treeniin.
                    Katto on korkealla ja puitteet monipuolisen fysiikkaharjoitteluun ovat kunnossa.
                    Dynamosali on erittäin hyvä harjoituspaikka niin aloittelevalle kuntoilijalle kuin vaativalle
                    urheilijalle.</p>

                <p>Kulkukortilla treenaat siihen aikaan mikä sinulle sopii parhaiten. Meillä on <a
                        href="/treenit-aukioloajat">ryhmätunteja</a>
                    kevyemmistä kehonhuollosta ja Pilateksesta aina kova
                    tehoisiin Savottoihin. </p>
                <!--
                                <p>Kulkukortilla treenaamaan pääsee joka päivä aamuviidestä iltayhteentoista, juuri
                                    siihen aikaan kuin sinulle sopii parhaiten.</p>
                                <h3>Mikä sinua odottaa Dynamosalilla ?</h3>
                                <p>Salilta löytyy mm. painonnostolavat sekä useita vapaiden painojen
                                    harjoittelupistettä, käsipainoja, kahvakuulia, smith kyykkyteline, voimistelurenkaita, pitkät
                                    leuanvetotangot, vastuskumeja, kuntopallon heittopaikka, kelkkarata, Plyobox-hyppykorokkeet sekä
                                    tietysti reilusti rautaa ja painonnostotankoja.</p>
                                -->


                <ul class="whyDynamo">
                    <li>
                        <div>
                            <strong>TREENITILAA KAHDESSA TASOSSA</strong><br/>
                            Kahdessa tasossa mm. neljä painonnostolavaa, kelkkarata, kyykky- ym. telineet sekä erillinen
                            lämmittely- ja venyttelytila.
                        </div>
                    </li>
                    <li>
                        <div>
                            <strong>PUITTEET MONIPUOLISEEN HARJOITTELUUN</strong><br/>
                            Runsaasti vapaita painoja, kahvakuulia, kuntopalloja, käsipainoja...
                        </div>
                    </li>
                    <li>
                        <div>
                            <strong>OSAAVA VALMENNUSTIIMI</strong><br/>
                            Koulutetut ja osaavat personal trainerit käytössäsi!
                        </div>
                    </li>
                    <li>
                        <div>
                            <strong>INNOSTAVA ILMAPIIRI</strong><br/>
                            Tervetuloa kehittymään!
                        </div>
                    </li>
                </ul>


                <h3>Monipuolinen valikoima treenivälineitä varmistaa tulokselliset treeniolosuhteet</h3>
                <p>Dynamosalilta löytyy kaikki tarvittavat toiminnalliseen treeniin, voimaharjoitteluun,
                    painonnostoon, kuntosaliharjoitteluun sekä muuhun kuntoiluun:</p>
                <ul class="whyDynamo">
                    <li>9 kyykkypaikkaa</li>
                    <li>4 painonnostolavaa</li>
                    <li>20+ levytankoa painonnostoon, voimanostoon, yms. (20kg, 15kg, 10kg)</li>
                    <li>Kyykkyräkki turvaraudoilla</li>
                    <li>Kelkkarata ja 2 kelkkaa</li>
                    <li>20+ leuanvetotankoa</li>
                    <li>Kisamallin kahvakuulat 8 - 40kg</li>
                    <li>Kuntopallot 3 - 20kg</li>
                    <li>Strongman säkit 45, 68 ja 90 kg</li>
                    <li>2 Powerbag säkit 15 kg</li>
                    <li>Juoksumatto</li>
                    <li>3 Concept2 soutulaitetta</li>
                    <li>Concept2 BikeErg -ergometri</li>
                    <li>SkiErg-hiihtolaite</li>
                    <li>Rogue Echo Bike V3.0</li>
                    <li>Spinning-pyörä</li>
                    <li>7 voimistelurenkaat</li>
                    <li>4 Penkkipunnerruspaikkaa</li>
                    <li>Useita tasa- ja vinopenkkejä</li>
                    <li>2 Käsipainopistettä. Ylhäällä sekä alhaalla - hexagon 3kg - 40kg</li>
                    <li>2 Dippitelinettä</li>
                    <li>Smith-laite</li>
                    <li>Ristitalja</li>
                    <li>Ylatalja</li>
                    <li>Reiden koukistus/ojennuslaite</li>
                    <li>Reiden loitunnuslaite</li>
                    <li>Lantionnostolaite</li>
                    <li>Kulmasoutulaite</li>
                    <li>Kädenvääntöpöytä</li>
                    <li>Selänojennuspenkki</li>
                    <li>Vatsarutistuspenkki</li>
                    <li>Hyppynaruja</li>
                    <li>Palloja, rullia ym. pienvälineitä kehonhuoltoon</li>
                    <li>Nostovöitä, nostohihnat ym. välineitä harjoittelusi tueksi</li>
                    <li>Magnesiumia otteen parantamiseksi</li>
                    <li>Sekä ilmaiset kahvit!</li>
                </ul>
                <br>
                <p>Frisbeegolffari Römpi on tehnyt saliesittelyn, joka kannattaa katsoa:</p>
                <div style="width: 100%; min-width: 400px; max-width: 800px;">
                    <div style="position: relative; width: 100%; overflow: hidden; padding-top: 56.25%;">
                        <iframe style="position: absolute; top: 0; left: 0; right: 0; width: 100%; height: 100%; border: none;" src="https://www.youtube.com/embed/Fj-_gAnm1Co?start=15"
                                title="RÖMPI DISTANCEKUNTOON 2025 | Saliesittely" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>

                <h3 class="sectionTitle">AVOINNA</h3>
                <ul class="infoList">
                    <li>Kulkuavaimella joka päivä 05 - 23</li>
                    <li>Vastaanotto:</li>
                    <li>Ma, Ti ja To klo 17.30 - 20.00</li>
                    <li>info@dynamosali.com</li>
                    <li><a target="_blank"
                           href="https://www.google.com/maps/place/Kissankulma+2,+90440+Kempele/@64.9088693,25.5155406,17z/data=!3m1!4b1!4m5!3m4!1s0x4681cb89936b8629:0x248500c57fcf2df5!8m2!3d64.9088693!4d25.5177294">
                        Karttalinkki</a></li>
                </ul>

                <h3 class="sectionTitle">YHTEYSTIEDOT</h3>
                <ul class="infoList">
                    <li>Dynamosali Oy</li>
                    <li>Kissankulma 2</li>
                    <li>90440 Kempele</li>
                    <li></li>
                    <li>p. 041 4337 877 (Petteri)</li>
                    <li>p. 0500 130 130 (Markus)</li>
                    <li></li>
                    <li>info@dynamosali.com</li>
                </ul>


                <div class="gymGallery">

                    {#each images as image, i}
                        <img class="gymImg"
                             on:click={() => imgOpen(image.src, image.alt)}
                             src={image.src} alt={image.alt}/>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>

<div bind:this={modal} class="modal">
    <span bind:this={closeSpan} class="close">&times;</span>
    <img bind:this={modalImg} class="modal-content" alt="">
    <div class="caption" bind:this={caption}></div>
</div>

<style>
    .whyDynamo {
        padding: 8px 10%;
    }

    .whyDynamo li {
        padding: 4px;
    }

    main {
        height: 75vh;
    }

    .infoList {
        list-style-type: none;
        padding: 0px 8%;
    }

    .sectionTitle {
        font-weight: bold;
        font-size: 1.2em;
        padding: 24px 8% 0;
    }

    .gymGallery img {
        opacity: .9;
        transition: all .2s
    }

    .gymGallery img:hover {
        opacity: 1;
        transform: scale(1.02)
    }

    .gymImg {
        border-radius: 5px;
        cursor: pointer;
        transition: 0.3s;
        width: 100%;
        max-width: 200px;
        margin: 8px;
    }

    .gymImg:hover {
        opacity: 0.7;
    }

    .modal {
        display: none;
        position: fixed;
        z-index: 1;
        padding-top: 100px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgb(0, 0, 0);
        background-color: rgba(0, 0, 0, 0.9);
    }

    .modal-content {
        margin: auto;
        display: block;
        width: 80%;
        max-width: 800px;
    }

    .caption {
        margin: auto;
        display: block;
        width: 80%;
        max-width: 700px;
        text-align: center;
        color: #ccc;
        padding: 10px 0;
        height: 150px;
    }

    .modal-content, .caption {
        animation-name: zoom;
        animation-duration: 0.6s;
    }

    @keyframes zoom {
        from {
            transform: scale(0)
        }
        to {
            transform: scale(1)
        }
    }

    .close {
        position: absolute;
        top: 15px;
        right: 35px;
        color: #f1f1f1;
        font-size: 40px;
        font-weight: bold;
        transition: 0.3s;
    }

    .close:hover,
    .close:focus {
        color: #bbb;
        text-decoration: none;
        cursor: pointer;
    }

    .gymGallery::after {
        clear: both;
    }

    @media only screen and (max-width: 700px) {
        .modal-content {
            width: 100%;
        }

        .gymImg {
            border-radius: 2px;
            width: 90%;
            max-width: 130px;
            margin: 2px;
        }
    }
</style>
